/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var allDatePickerEls = document.querySelectorAll('[data-moya-component="rnb.flatpickr"]');
    var numberOfDatePickersInitialized = 0;
    (function register() {
        var deps = [];
        deps.push('https://cdn.jsdelivr.net/npm/flatpickr@4.6.9/dist/flatpickr.min.js');
        deps.push('https://cdn.jsdelivr.net/npm/flatpickr@4.6.9/dist/flatpickr.min.css');
        var lang = document.documentElement.lang;
        var locale = lang === 'is' ? lang : 'en';
        if (locale === 'is') {
            deps.push("https://cdn.jsdelivr.net/npm/flatpickr@4.6.9/dist/l10n/" + locale + ".js");
        }
        MoyaComponents.register('rnb.flatpickr', deps, function (el) {
            var opts = {
                dateFormat: 'd.m.Y',
                locale: locale,
                disableMobile: el.dataset.disableMobile !== 'false',
            };
            var instance = flatpickr(el, opts);
            if (el.value) {
                instance.setDate(el.value);
            }
            MoyaContainer.set('rnb.datepicker-' + el.id, instance);
            numberOfDatePickersInitialized += 1;
            if (numberOfDatePickersInitialized === allDatePickerEls.length) {
                MoyaEventHandler.dispatch('rnb.datepickers-initialized', {});
            }
        });
    })();

}());
typeof tsBuild === 'function' && tsBuild();})();
